import axios from 'axios';
import root from 'window-or-global';

import FeaturedIslandsActions from '../actions/FeaturedIslandsActions';
import Url from '../constants/Url';

/**
 * FeaturedIslandsSource
 *
 * Responsible for making the ajax calls to retrieve islands from creative service.
 *
 * For more information on source usage:
 * http://alt.js.org/docs/async/
 *
 */
const FeaturedIslandsSource = {
  addFavorites: {
    remote(state, islandCode) {
      const api = Url().CREATIVE.FAVORITE_ISLAND;
      return axios.put(`${api}/${islandCode}`);
    },
    success: FeaturedIslandsActions.addFavoritesSuccess,
    error: FeaturedIslandsActions.addFavoritesFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },

  addToPlaylist: {
    remote(state, islandCode) {
      const api = Url().CREATIVE.ADD_TO_PLAYLIST;
      return axios.post(`${api}/${islandCode}`, null);
    },
    success: FeaturedIslandsActions.addToPlaylistSuccess,
    error: FeaturedIslandsActions.addToPlaylistFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },

  checkPlaylist: {
    remote(state, islandCode) {
      const api = Url().CREATIVE.CHECK_PLAYLIST_QUEUE;
      return axios.post(`${api}/${islandCode}`, null);
    },
    success: FeaturedIslandsActions.checkPlaylistSuccess,
    error: FeaturedIslandsActions.checkPlaylistFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },

  removeFromPlaylist: {
    remote(state, islandCode) {
      const api = Url().CREATIVE.REMOVE_FROM_PLAYLIST;
      return axios.delete(`${api}/${islandCode}`);
    },
    success: FeaturedIslandsActions.removeFromPlaylistSuccess,
    error: FeaturedIslandsActions.removeFromPlaylistFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },

  getIslandsForUser: {
    async remote(state, accountId) {
      const api = Url().USER_ISLANDS;
      return axios.get(`${api}/${accountId}`);
    },
    success: FeaturedIslandsActions.getIslandsForUserSuccess,
    error: FeaturedIslandsActions.getIslandsForUserFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default FeaturedIslandsSource;
